import React from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import { ISearch } from "context/SearchContext";
dayjs.locale("fr");

interface BookingSummaryProps {
  currentParams: { start?: string; end?: string; [key: string]: any };
  searchData: ISearch;
  handleStepChange: (step: number) => void;
}

export const BookingSummary: React.FC<BookingSummaryProps> = ({
  currentParams,
  searchData,
  handleStepChange,
}) => {
  const formatDate = (date: string | Date) => {
    const formatted = dayjs(date).format("ddd DD/MM/YYYY");
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };

  return (
    <div className="flex justify-evenly border p-4 w-full bg-white mb-10">
      <div>
        <div className="flex justify-between items-center">
          <div>
            <p className="font-semibold">Séjour</p>
            <p className="text-sm">
              {currentParams?.start && formatDate(currentParams.start)} →{" "}
              {currentParams?.end && formatDate(currentParams.end)}
            </p>
          </div>
        </div>
      </div>

      <div>
        <div className="flex justify-between items-center">
          <div>
            <p className="font-semibold">Occupation</p>
            <p className="text-sm">
              {(() => {
                const adultCount =
                  searchData.rooms?.reduce(
                    (acc, room) => acc + room.guestAdults,
                    0
                  ) || 0;
                const childCount =
                  searchData.rooms?.reduce(
                    (acc, room) => acc + (room.guestChildren?.length || 0),
                    0
                  ) || 0;

                return (
                  <>
                    {adultCount > 1
                      ? `${adultCount} Adultes`
                      : `${adultCount} Adulte`}
                    {childCount > 0 &&
                      ` et ${
                        childCount > 1
                          ? `${childCount} enfants`
                          : `${childCount} enfant`
                      }`}
                  </>
                );
              })()}
            </p>
          </div>
        </div>
      </div>
      <ButtonPrimary
        className="border !bg-white !text-black rounded-none w-24"
        onClick={() => handleStepChange(0)}
      >
        Modifier
      </ButtonPrimary>
    </div>
  );
};
